import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-footer",
    styles: [
        `
      .link, p {
        font-size: 0.9rem;
      }

      footer {
        box-sizing: border-box;
        margin-bottom: 0;
        border-bottom: none;
      }
      
      .link {
        font-size: 0.9rem;
        line-height: 1.428;
        @media screen and (max-width: 576px) {
          font-size: 0.8rem;
        }
      }
    `,
    ],
    template: `
    <footer class="bg-dark d-flex gap-3 gap-md-5 justify-content-center align-items-center py-4 w-100 text-center">
      <div>
        <a [routerLink]="['', 'terms-and-conditions']" class="link text-light-gray no-underline">{{ 'footer.component.condizioni-generali' | translate }}</a>
      </div>
      <div>
        <a [routerLink]="['', 'privacy-policy']" class="link text-light-gray no-underline">{{ 'footer.component.informativa-privacy' | translate }}</a>
      </div>
      <div>
        <a href="https://www.iubenda.com/privacy-policy/61662904/cookie-policy" target="_blank" class="link m-0 text-light-gray no-underline">Cookie policy</a>
      </div>
    </footer>
  `,
    imports: [RouterLink, TranslateModule]
})
export class FooterComponent {
  constructor() {}
}
